import React from "react";
import FilterTitle from "../../../Category/Filter/Common/FilterTitle";
import Text from "../../../Category/Filter/Common/Text";
import { regionData } from "../../../../data/regionData";

const Location = () => {
  return (
    <div className="border-b border-darkGreen border-opacity-40 px-7 py-8">
      <FilterTitle title={"Choose location"} />
      <div className="mb-2 flex flex-col gap-4 px-3">
        {regionData.map((location) => (
          <Text
            key={location.id}
            text={location.name}
            amount={location.amount}
          />
        ))}
      </div>
    </div>
  );
};

export default Location;
